import React from 'react';
import get from 'lodash/get';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import Role from '../../../consts/Role';
import { Switch } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

const ROLE_ID = Role.CUSTOMERROLE_ADOPERATION.getCode();

export default class AdOperationTab extends React.Component {
  componentDidMount() {}

  constructor(props) {
    super(props);
    this.state = {
      leadsEncryptChecked: get(props, ['encrypt', ROLE_ID, 'leads'], false),
      qwEncryptChecked: get(props, ['encrypt', ROLE_ID, 'qw'], false),
    };
  }
  toggleDataEncrypt(checked) {
    this.setState({ leadsEncryptChecked: checked });
    checked = checked ? 1 : 0;
    RPCFactory.account
      .updateEncryptionConfig(ROLE_ID, checked)
      .done((data) => {
        this.props.update && this.props.update('leads', ROLE_ID, checked);
      })
      .fail((ret, msg) => {
        window.alert(`修改失败，错误信息：${msg}`);
      });
  }

  toggleQwEncrypt(checked) {
    this.setState({ qwEncryptChecked: checked });
    checked = checked ? 1 : 0;
    RPCFactory.account
      .updateQwEncryptionConfig(ROLE_ID, checked)
      .done((data) => {
        this.props.update && this.props.update('qw', ROLE_ID, checked);
      })
      .fail((ret, msg) => {
        window.alert(`修改失败，错误信息：${msg}`);
      });
  }

  render() {
    const canShowEncryptSwitch = window.pageProps.privileges.includes(PrivilegeCode.LEADS_ENCRYPTION_VIEW.getCode());

    return (
      <div>
        <div className="limits">
          <ul className="set-list">
            <li className="setli">
              <span className="setli-tt">线索管理</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看线索列表</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">查看线索数据详情</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">导出线索数据</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">标记线索状态、线索评分</em>
                  </label>
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">分配线索</em>
                  </label>
                </div>
              </div>
            </li>
            <li className="setli">
              <span className="setli-tt">分析应用</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">上报规则设置</em>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="limits">
          {canShowEncryptSwitch && (
            <div className="set-title">
              <span className="setli-tt-dark">数据权限</span>
              <span className="wd-switch">
                线索数据加密
                <Switch
                  key={this.state.leadsEncryptChecked}
                  checked={this.state.leadsEncryptChecked}
                  onChange={(event, checked) => {
                    this.toggleDataEncrypt(checked);
                  }}
                ></Switch>
              </span>
              <span className="wd-switch">
                企微数据加密
                <Switch
                  key={this.state.qwEncryptChecked}
                  checked={this.state.qwEncryptChecked}
                  onChange={(event, checked) => {
                    this.toggleQwEncrypt(checked);
                  }}
                ></Switch>
              </span>
            </div>
          )}
          <ul className="set-list">
            <li className="setli">
              <span className="setli-tt">数据范围</span>
              <div className="set-in">
                <div className="simple-check spa-ui-group spaui-component">
                  <label className="spaui-checkbox">
                    <input type="checkbox" className="check" checked disabled name="" value="0" />
                    <span className="ico"></span>
                    <em className=" spaui-checkbox-text">全公司</em>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
